import { useMutation } from '@tanstack/react-query'

import { updateEvidenceImage } from '@src/api'
import { DefaultApiUpdateEvidenceImageRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUpdateEvidenceImage = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUpdateEvidenceImageRequest) =>
      updateEvidenceImage(axiosInstance, params),
  })
}
